var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"dataset unpaired",on:{"click":function($event){return _setup.emit('element-is-selected', _vm.element)}}},[_c('label',[_vm._v("\n        "+_vm._s(_vm.element.name)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }